module.exports = __webpack_public_path__ + "img/um.um867207f.svg";